import { render, staticRenderFns } from "./UnitNameInput.vue?vue&type=template&id=552c1e5f&"
import script from "./UnitNameInput.vue?vue&type=script&lang=ts&"
export * from "./UnitNameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports